import { useRoom } from '@/contexts/RoomContext'
import { UserGridProps } from '@/types'
import ConnectedControlBar from '../ControlBar'
import { UserCard } from './UserCard'

export const UserGrid: React.FC<UserGridProps> = () => {
  const roomContext = useRoom()
  if (!roomContext) {
    return (
      <div className="bg-gray-600 w-2/6 h-full flex flex-col p-4 grow">
        <div className="grid gap-4 flex-grow justify-center items-center">
          <div className="flex flex-col items-center justify-center space-y-2">
            <div className="spinner-border animate-spin border-4 border-t-4 border-gray-300 border-solid rounded-full w-16 h-16"></div>
            <p className="text-white text-lg">Loading Room...</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="bg-gray-600 w-2/6 h-full flex flex-col p-4 grow">
      <div className="grid grid-cols-2 gap-4 flex-grow">
        {Array.from(roomContext.users.values()).map((user) => (
          <UserCard
            key={user.id}
            name={user.name}
            avatar={user.avatar || ''}
            streams={user.tracks}
          />
        ))}
      </div>

      <ConnectedControlBar />
    </div>
  )
}
